var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-banner"},[_c('LocalLoader',{staticStyle:{"width":"80px","height":"20px","padding-bottom":"15px"},attrs:{"height":20,"verySmall":""}}),_c('span',{staticClass:"text",staticStyle:{"padding-top":"5px"}},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }